/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A routing profile that determines which roads are eligible for matching (e.g. trucks probably aren't on sidewalks, so the search will snap to the nearest truck-accessible road).
 * @export
 */
export const NearestRoadsCostingModel = {
  Auto: "auto",
  Bus: "bus",
  Taxi: "taxi",
  Truck: "truck",
  Bicycle: "bicycle",
  Bikeshare: "bikeshare",
  MotorScooter: "motor_scooter",
  Motorcycle: "motorcycle",
  Pedestrian: "pedestrian",
  LowSpeedVehicle: "low_speed_vehicle",
} as const;
export type NearestRoadsCostingModel =
  (typeof NearestRoadsCostingModel)[keyof typeof NearestRoadsCostingModel];

export function instanceOfNearestRoadsCostingModel(value: any): boolean {
  for (const key in NearestRoadsCostingModel) {
    if (Object.prototype.hasOwnProperty.call(NearestRoadsCostingModel, key)) {
      if (
        NearestRoadsCostingModel[
          key as keyof typeof NearestRoadsCostingModel
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function NearestRoadsCostingModelFromJSON(
  json: any,
): NearestRoadsCostingModel {
  return NearestRoadsCostingModelFromJSONTyped(json, false);
}

export function NearestRoadsCostingModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NearestRoadsCostingModel {
  return json as NearestRoadsCostingModel;
}

export function NearestRoadsCostingModelToJSON(
  value?: NearestRoadsCostingModel | null,
): any {
  return value as any;
}

export function NearestRoadsCostingModelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): NearestRoadsCostingModel {
  return value as NearestRoadsCostingModel;
}
